var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-grid',{attrs:{"grid-type":9}})
}
var staticRenderFns = []

export { render, staticRenderFns }